<template>
  <offer-sale-base :offer-sale="offerSale" :is-group="isGroup" type="takepay_offer_sales" :is-activable="isActivable">
    <template v-slot:line-1>
      <offer-sale-line :line-items="isGroup ? takePayItems : productInfoItems" />
    </template>

    <template v-slot:line-2>
      <offer-sale-line :line-items="isGroup ? maxCpfItem : takePayItems">
        <user-consumption v-if="isGroup" :maximum-per-client="offerSale.maximum_per_client" :user-sale-consumption-amount="userSaleConsumptionAmountInGroup" />
      </offer-sale-line>
    </template>

    <template v-if="!isGroup" v-slot:line-3>
      <offer-sale-line :line-items="maxCpfItem">
        <user-consumption :maximum-per-client="offerSale.maximum_per_client" :user-sale-consumption-amount="offerSale.user_sale_consumption_amount" />
      </offer-sale-line>
    </template>
  </offer-sale-base>
</template>

<script>
import OfferSaleBase from './OfferSaleBase.vue'
import OfferSaleLine from './OfferSaleLine.vue'
import UserConsumption from './UserConsumption.vue'

export default {
  name: 'TakePayOfferSale',
  components: {
    OfferSaleBase,
    OfferSaleLine,
    UserConsumption,
  },
  props: {
    offerSale: {
      type: Object,
      required: true,
    },
    isActivable: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isGroup() {
      return this.offerSale.takepay_offer_sales && this.offerSale.takepay_offer_sales.length > 0
    },
    userSaleConsumptionAmountInGroup() {
      return this.offerSale.takepay_offer_sales.reduce((acc, takepayOfferSale) => acc + takepayOfferSale.user_sale_consumption_amount, 0)
    },
    productInfoItems() {
      return [
        {
          label: 'SKU',
          value: this.offerSale.sku,
          format: 'text',
        },
        {
          label: 'EAN',
          value: this.offerSale.ean,
          format: 'text',
        },
      ]
    },
    takePayItems() {
      return [
        {
          label: 'Leve',
          value: this.offerSale.take,
          format: 'text',
        },
        {
          label: 'Pague',
          value: this.offerSale.pay,
          format: 'text',
        },
      ]
    },
    maxCpfItem() {
      return [
        {
          label: 'Máx. CPF',
          value: this.offerSale.maximum_per_client,
          format: 'text',
        },
      ]
    },
  },
}
</script>
